import { getServices } from 'api/routes';
import React, { useEffect, useRef, useState } from 'react'
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import { Editor } from 'react-draft-wysiwyg';
import editorToolbar from './../../components/editorToolbar';
import { deleteServices, newServices, newServicesImage, updateServices } from './../../api/routes';
import draftToHtml from 'draftjs-to-html';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import urltoFile from './../../components/urlToFile';
import { Backdrop, CircularProgress, Icon, Modal } from '@mui/material';
import parse from 'html-react-parser';
import htmlToDraft from 'html-to-draftjs';
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: '500px',
    overflowY: 'scroll'
};

export default function Services() {
    const [addService, setAddService] = useState(false);
    const [services, setServices] = useState([]);
    const [openFullDesc, setOpenFullDesc] = useState(false);
    const handleCloseFullDesc = () => setOpenFullDesc(false);
    const handleOpenFullDesc = () => setOpenFullDesc(true);
    const [updateProcess, setUpdateProcess] = useState(false)
    const [clickedServiceDesc, setClickedServiceDesc] = useState();
    const [clickedServiceId, setClickedServiceId] = useState();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const [serviceTitle, setServiceTitle] = useState()
    const [serviceShortText, setServiceShortText] = useState()
    const [sort, setSort] = useState()
    const [editorState, setEditorState] = useState();
    const [isImageUpload, setIsImageUpload] = useState(false);

    const file = useRef(null);

    useEffect(() => {
        handleOpen()
        getServices((isOk, data) => {
            if (!isOk) {
                handleClose()
                toast.error(data.message);
            }
            else {
                handleClose()
                return setServices(data)
            }
        })
    }, [])


    const uploadImage = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 < 6) {
                const reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (event) => {
                    sessionStorage.setItem("serviceimage", event.target.result);
                    setIsImageUpload(true)
                };
            } else toast.error("حجم فایل باید کمتر از 6 مگابایت باشد");
        }
    }

    const newService = () => {
        if (serviceTitle && serviceShortText && editorState.getCurrentContent().hasText() && sessionStorage.getItem('serviceimage') !== null) {
            handleOpen();
            const data = {
                serviceTitle,
                serviceShortText,
                sort,
                serviceText: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
            newServices(data, (isOk, data) => {
                if (!isOk) {
                    handleClose()
                    return toast.error(data.message);
                }

                else {
                    if (sessionStorage.getItem('serviceimage') !== null) {
                        urltoFile(sessionStorage.getItem('serviceimage'), 'file.jpeg', 'image/jpeg')
                            .then(function (file) {
                                let options = {
                                    maxSizeMB: 0.2,
                                }
                                imageCompression(file, options)
                                    .then(function (compressedFile) {
                                        const formData = new FormData();
                                        formData.append("serviceImage", new File([compressedFile], "file.jpeg", { type: "text/json;charset=utf-8" }));
                                        formData.append('serviceId', data[0].serviceId);
                                        newServicesImage(formData, (isOk, data) => {
                                            if (!isOk) return toast.error(data.message);
                                            else {
                                                sessionStorage.removeItem('serviceimage');
                                                return window.location.reload();
                                            }
                                        })
                                    })
                                    .catch(function (error) {
                                        console.log(error.message);
                                    });
                            })
                    } else return window.location.reload();
                }
            })
        } else return toast.error('تمام قسمت ها را پر کنید!')
    }

    const updateClicked = (clickedService) => {
        setClickedServiceId(clickedService.serviceId)
        setServiceShortText(clickedService.serviceShortText)
        setSort(clickedService.sort)
        setServiceTitle(clickedService.serviceTitle)
        const blocksFromHtml = htmlToDraft(clickedService.serviceText);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
        setUpdateProcess(true);
        setAddService(true);
    }

    const updateService = () => {
        const data = {
            serviceId: clickedServiceId,
            serviceTitle,
            sort,
            serviceShortText,
            serviceText: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        }
        handleOpen()
        updateServices(data, (isOk, data) => {
            if (!isOk) {
                handleClose()
                return toast.error(data.message);
            }

            else {
                if (sessionStorage.getItem('serviceimage') !== null) {
                    urltoFile(sessionStorage.getItem('serviceimage'), 'file.jpeg', 'image/jpeg')
                        .then(function (file) {
                            let options = {
                                maxSizeMB: 0.2,
                            }
                            imageCompression(file, options)
                                .then(function (compressedFile) {
                                    const formData = new FormData();
                                    formData.append("serviceImage", new File([compressedFile], "file.jpeg", { type: "text/json;charset=utf-8" }));
                                    formData.append('serviceId', clickedServiceId);
                                    newServicesImage(formData, (isOk, data) => {
                                        if (!isOk) return toast.error(data.message);
                                        else {
                                            sessionStorage.removeItem('serviceimage');
                                            return window.location.reload();
                                        }
                                    })
                                })
                                .catch(function (error) {
                                    console.log(error.message);
                                });

                        })
                } else return window.location.reload();
            }
        })
    }

    const deleteService = (seviceId) => {
        handleOpen()
        deleteServices(seviceId, (isOk, data) => {
            if (!isOk) {
                handleClose()
                return toast.error(data.message);
            }

            else return window.location.reload()
        })
    }
    return (
        <div style={{ margin: '1rem 0' }}>
            {services.map(service => <section key={service.serviceId} style={{ fontSize: '1rem', borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 0 0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da' }}>
                <img src={`data:image/jpeg;base64,${service.image}`} alt='prescription' style={{ width: '200px', height: '100px', objectFit: 'cover' }} />
                <p style={{ color: '#00000099' }}>عنوان : <span style={{ color: '#010101' }}>{service.serviceTitle}</span></p>
                <p style={{ color: '#00000099', width: '300px' }}>توضیح در صفحه اصلی : <span style={{ color: '#010101', fontSize: '14px' }}>{service.serviceShortText}</span></p>
                <section style={{ display: 'flex', alignItems: 'center' }}>
                    <MDButton onClick={() => { setClickedServiceDesc(service.serviceText); handleOpenFullDesc() }} variant="gradient" color="primary">
                        نمایش شرح
                    </MDButton>
                    <section style={{ display: 'flex', flexDirection: 'column', width: '20px', marginRight: '1rem',alignItems:'center' }}>
                        <MDButton variant="text" color="error" onClick={() => deleteService(service.serviceId)}>
                            <Icon>delete</Icon>
                        </MDButton>
                        <MDButton variant="text" color="info" onClick={() => updateClicked(service)}>
                            <Icon>edit</Icon>
                        </MDButton>
                        <p>{service.sort}</p>
                    </section>
                </section>
            </section>)}
            {!updateProcess && <MDButton onClick={() => setAddService(true)} variant="gradient" color="info" sx={{ marginTop: '2rem' }}>
                افزودن خدمت
            </MDButton>}

            {addService && <>
                <hr style={{ width: '100%', margin: '2rem 0' }} />
                <MDInput multiline type="text" label="عنوان" value={serviceTitle} onChange={(event) => setServiceTitle(event.target.value)} fullWidth />
                <MDInput multiline rows={5} type="text" value={serviceShortText} onChange={(event) => setServiceShortText(event.target.value)} label="توضیح در صفحه اصلی" fullWidth sx={{ margin: '1rem 0' }} />
                <MDInput type="text" label="ترتیب (فقط عدد)" value={sort} onChange={(event) => setSort(event.target.value)} fullWidth />
                <input ref={file} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage} />
                <div style={{ borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da', height: '56px' }} onClick={() => file?.current?.click()}>
                    <p style={{ color: '#00000099', fontSize: '1rem' }}>تصویر</p>
                    {isImageUpload ? <p style={{ color: 'rgb(74 222 128)', fontSize: '1rem' }}>آپلود شد</p> : <p style={{ color: '#00000099', fontSize: '1rem' }}>آپلود کنید</p>}
                </div>
                <MDBox style={{ direction: 'ltr', marginTop: '1rem' }}>
                    <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="body-editor"
                        placeholder='شرح'
                        onEditorStateChange={(editorState) => setEditorState(editorState)}
                        toolbar={editorToolbar()}
                    />
                </MDBox>
                <MDButton onClick={updateProcess ? () => updateService() : () => newService()} variant="gradient" color="info" sx={{ marginTop: '2rem' }}>
                    {updateProcess ? 'ویرایش' : 'افزودن'}
                </MDButton>
            </>}
            <Modal open={openFullDesc} onClose={handleCloseFullDesc}>
                <MDBox sx={style}>
                    <div style={{ fontSize: '1rem', fontFamily: 'IRANSansX' }}>{clickedServiceDesc && parse(clickedServiceDesc)}</div>
                </MDBox>
            </Modal>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
